import { render, staticRenderFns } from "./DomainDetailIframe.vue?vue&type=template&id=ee1b4dce&"
import script from "./DomainDetailIframe.vue?vue&type=script&lang=ts&"
export * from "./DomainDetailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports